module.exports = __webpack_public_path__ + "img/Primordial-2-mobile.abf364d5.png";